import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delay` ms: the result updates only after the input stops changing.
 * Used to debounce table search boxes so filtering a large list runs once after the user pauses,
 * not on every keystroke.
 */
export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
